module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAABXNvynAAAABGdBTUEAALGPC/xhBQAAAHxJREFUWAnt0rEJgDAYRGF1AQvXEdwg4IJuYOl8WgZel3CCwkuVgz9H+JJx26976FjnsXacqkeWMtfQsJsaZj8x6oXffgaFFYaAXwIg8ahwnBSFCgMkHhWOk6JQYYDEo8JxUhQqDJB4VDhOikKFARKPCsdJUagwQOLxd8IPs4YEd9mEPYkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag-icons/icons8-france.png
// module id = 1412
// module chunks = 33